import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

// (Icons)
import { MdClose } from "react-icons/md";

const ConnectionModal = ({ setIsOpenModal, clickedInfo }) => {
  const navigate = useNavigate();

  const [isLoading] = useState(true);
  const [isPrep, setIsPrep] = useState(true);

  // TODO: REMOVE LOADING AFTER FOR 6 SECONDS
  useEffect(() => {
    setTimeout(() => {
      setIsPrep(false);
    }, 6000);
  }, [isLoading]);

  return (
    <div
      className="connection-modal fixed top-0 left-0 right-0 w-full bg-[#000]/85 max-h-[100dvh] min-h-[100dvh] h-[100dvh] z-[9999999]"
      onClick={() => setIsOpenModal(false)}
    >
      <div className="w-full relative flex justify-center items-center py-10 h-full overflow-y-scroll shadow">
        <div
          className="w-full bg-[#ffffff] border border-[#cccccc0a] text-black px-4 py-4 md:max-w-[600px] max-w-[90%] mx-auto rounded-xl"
          onClick={(e) => e.stopPropagation()}
        >
          <main className="w-full h-full grid grid-rows-[auto_1fr]">
            <header className="w-full flex items-start justify-between">
              <div>
                <div className="w-auto flex items-center gap-1 px-1">
                  <div>
                    <img
                      src={clickedInfo.image}
                      alt={"This wallet"}
                      className="w-12 rounded-lg bg-white p-1 object-cover"
                      draggable={false}
                    />
                  </div>
                  <div className="flex flex-col">
                    <h3 className="font-semibold text-xl">
                      {clickedInfo.name}
                    </h3>
                  </div>
                </div>
              </div>
              <div>
                <button
                  onClick={() => setIsOpenModal(false)}
                  className="p-1 bg-secondary/10 text-black rounded-full cursor-pointer"
                >
                  <MdClose size={25} />
                </button>
              </div>
            </header>

            <section className="w-full bg-transparent py-4 md:px-2">
              {isLoading && (
                <>
                  {isPrep && (
                    <>
                      <div>
                        <div className="heading-line s2"></div>
                        <br />
                        <h2 className="please-h2">
                          Starting secure connection...
                        </h2>
                        <p className="please-wait">please wait</p>
                      </div>
                    </>
                  )}
                  {!isPrep && (
                    <div className="flex flex-col justify-center gap-2 items-center">
                      <div className="w-full h-full mt-3 p-2 flex flex-col justify-center items-center text-center border border-red-500 rounded-md">
                        <p className="text-red-500 font-semibold">
                          An error occurred... please try again or connect
                          manually
                        </p>
                      </div>

                      <div className="gp-btn">
                        <button
                          onClick={() =>
                            navigate(`/account/connect/${clickedInfo.name}`)
                          }
                        >
                          Try Again
                        </button>
                        <button
                          onClick={() =>
                            navigate(`/account/connect/${clickedInfo.name}`)
                          }
                        >
                          Connect Manually
                        </button>

                        <div className="w-full text-center py-3">
                          <h4> This Session is Secured and encrypted</h4>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
            </section>
          </main>
        </div>
      </div>
    </div>
  );
};

export default ConnectionModal;
